import { render, staticRenderFns } from "./ModalImportContent.vue?vue&type=template&id=08ee716e"
import script from "./ModalImportContent.vue?vue&type=script&lang=js"
export * from "./ModalImportContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports